(() => {
  const links=[...document.querySelectorAll('[data-box-cart]')];
  function refresh(explicit){
    links.forEach(link=>{
      const key=link.dataset.preview==='true'?'browndog-box-preview':'browndog-box-draft';
      let count=0;
      try {const entries=JSON.parse(sessionStorage.getItem(key)||'[]');count=entries.reduce((n,entry)=>n+(Array.isArray(entry)&&Number.isInteger(entry[1])&&entry[1]>0?entry[1]:0),0);const options=JSON.parse(sessionStorage.getItem(key+'-purchase')||'{}');if(options.vip&&options.purchase==='subscribe')count++;}catch(e){}
      if(Number.isInteger(explicit))count=explicit;
      const selected=count>0;
      if(!selected)count=Number(link.dataset.cartCount)||0;
      link.querySelector('[data-box-count]').textContent=count;
      link.setAttribute('aria-label',selected?`Cart: ${count} pints selected in your box`:`Cart: ${count} items`);
      let savedCart=false;try{savedCart=!!sessionStorage.getItem(key+'-cart-id');}catch(e){}
      link.href=savedCart&&link.dataset.preview!=='true'?'/cart':selected?(link.dataset.preview==='true'?'box-builder-preview.html':'/collections/flavors?view=bdj-box'):(link.dataset.preview==='true'?'review-cart-preview.html':'/cart');
    });
  }
  document.addEventListener('browndog:box-change',e=>refresh(e.detail.count));
  window.addEventListener('pageshow',()=>refresh());
  refresh();
})();
